import React, { useState, useEffect } from 'react';
import NavBar from '../Components/NavBar';
import "./LandingPage.css";
import Downarrow from "../Icons/Down-arrow.svg";
import Brands from '../Components/Brands';
import Products from '../Components/Products';
import smallerdownarrow from '../Icons/smaller-downarrow.svg';
import { createClient } from '@supabase/supabase-js';
import { useNavigate } from 'react-router-dom';
import Hanger from "../Icons/hanger.svg";
import Dollar from "../Icons/dollar.svg";
import Ship from "../Icons/ship.svg";
import Fakewebsite from "../Icons/fakewebsite.png";
import Discover from "../Icons/Discover.svg";
import AmEx from "../Icons/amEx.svg";
import group from "../Icons/Group.svg";
import visa from "../Icons/visa.svg";
import box from "../Icons/Box.png";
import confetti from "../Icons/confetti.svg";
import Footer from "../Components/Footer";
import jewelry from '../Icons/jewelry.png';
const supabaseUrl = "https://vfcfuprvvwwflestsagt.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmY2Z1cHJ2dnd3Zmxlc3RzYWd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTI3Mjg3NDksImV4cCI6MjAyODMwNDc0OX0.qx0UswYWrVW4yjmyeY4RuKtv1fW9kWXJd8wUtdl5RdI";

// Initialize Supabase client
const supabase = createClient(supabaseUrl, supabaseKey);

const LandingPage = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [popupProductInfo, setPopupProductInfo] = useState(null);
    const [showTrending, setShowTrending] = useState(false);
    const [productUrl, setProductUrl] = useState('');
    const navigate = useNavigate();
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    // pasted from navbar
    const handleCartClick = () => {
        navigate('/cart', ); // Navigate to /cart route
        
    };

    const handleScrollToSlab = () => {
        const slabElement = document.getElementById('howtocartpool');
        if (slabElement) {
          slabElement.scrollIntoView({ behavior: 'smooth' });
        }
      };
      

    useEffect(() => {
        const handleScroll = () => {
            const trendingNumber1 = document.querySelector('.trending-number1');
            if (trendingNumber1) {
                const bounding = trendingNumber1.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                if (bounding.top < windowHeight && bounding.bottom > 0) {
                    setShowTrending(true);
                } else {
                    setShowTrending(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    


    useEffect(() => {
        const banner = document.querySelector('.banner');

        if (banner) {
            const bannerText = banner.textContent || '';

            // Clone and append the text to ensure the banner is always filled
            if (bannerText) {
                banner.innerHTML += bannerText;

                // Set animation to move the text
                banner.style.animation = `moveBanner 20s linear infinite`;
                const textWidth = banner.clientWidth;
                const animationDuration = textWidth / 100;
                banner.style.animationDuration = `${animationDuration}s`;
            }
        }
    }, []);

    
    const BrandsData = [
        {
            imageUrl: "https://m.en.sound-wave.co.kr/web/upload/share-image-5-569fde966c8ab0a3ac2eb88a106d9c73.jpg",
            websiteLink: "https://en.sound-wave.co.kr/category/music/44/"
        },
    
        {
            imageUrl: "https://medleyjewellery.com.au/cdn/shop/files/Medley_Jewellery_Logo.png?v=1662352756",
            websiteLink: "http://medleyjewellery.com.au"
        },
        {
            imageUrl: "https://m.en.sound-wave.co.kr/web/upload/share-image-5-569fde966c8ab0a3ac2eb88a106d9c73.jpg",
            websiteLink: "https://en.sound-wave.co.kr/category/music/44/"
        },
    
        {
            imageUrl: "https://medleyjewellery.com.au/cdn/shop/files/Medley_Jewellery_Logo.png?v=1662352756",
            websiteLink: "http://medleyjewellery.com.au"
        },
        {
            imageUrl: "https://m.en.sound-wave.co.kr/web/upload/share-image-5-569fde966c8ab0a3ac2eb88a106d9c73.jpg",
            websiteLink: "https://en.sound-wave.co.kr/category/music/44/"
        },
    
        {
            imageUrl: "https://medleyjewellery.com.au/cdn/shop/files/Medley_Jewellery_Logo.png?v=1662352756",
            websiteLink: "http://medleyjewellery.com.au"
        },
        
    ];

    const trendingProducts = [
        {
            productName: "피커스 - 미니앨범1집 [Little Prince] (PICKUS - 1ST MINI ALBUM [Little Prince])",
            price: 17.10,
            image: "https://en.sound-wave.co.kr/web/product/big/202404/b246a612100c3d458e9468e2c80dc327.jpg",
            productLink: "https://en.sound-wave.co.kr/product/피커스-미니앨범1집-little-prince-pickus-1st-mini-album-little-prince/15463/category/44/display/1/"
        },
        {
            productName: "김하온 (HAON) - HAONOAH (HAON - HAONOAH)",
            price: 14.90,
            image: "https://en.sound-wave.co.kr/web/product/big/202404/09af6c1d8c166247731c4f49e5c0c0d7.jpg",
            productLink: "https://en.sound-wave.co.kr/product/김하온-haon-haonoah-haon-haonoah/15357/category/44/display/1/"
        },
        {
            productName: "diamond suspender bar single earring in 10k gold",
            price: 229,
            image: "https://medleyjewellery.com.au/cdn/shop/files/diamond-suspender-bar-single-earring-in-10k-gold-medley-jewellery-earrings-40466671861990.jpg?v=1708051242&width=1800",
            productLink: "https://medleyjewellery.com.au/products/diamond-suspender-bar-single-earring-in-10k-gold"
        }
    ];
    
    const handleSearch = async (e) => {
        e.preventDefault();
        console.log(productUrl);
    
        try {
            const { data, error } = await supabase
                .from('products')
                .select('product_name, price, image_url')
                .eq('product_url', productUrl)
                .single();
    
            if (error) {
                console.error('Error searching for product:', error.message);
                return;
            }
    
            if (data) {
                // Set the product information for the pop-up
                setPopupProductInfo(data);
                // Show the pop-up
                setShowPopup(true);
            } else {
                console.log('Product not found');
            }
        } catch (error) {
            console.error('Error searching for product:', error.message);
        }
    };
    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const handleAddToCart = () => {
        const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
        // Append the new product to the existing cart items
        const updatedCart = [...existingCart, popupProductInfo];
        // Update local storage with the updated cart items
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        // Hide the pop-up after adding to cart
        setShowPopup(false);
        setShowSuccessMessage(true);
        // Hide success message after 5 seconds
        setTimeout(() => {
            setShowSuccessMessage(false);
        }, 3000);
    };
    
    // Render the pop-up if showPopup is true
    


    return (
        <div>
            <NavBar handleCartClick={handleCartClick}/> 
            <div className='rectangle'>
                <div className='search-box'>
                    <div>
                    <h1>
                        <div className='savecost'>Seamless International Shipping</div>
                    </h1>
                    
                    <h3 className='first-platform'>the 1st group shipping platform!</h3>
                    </div> 
                    <div className='inner-search-box'>
                        <div className='paste-link-txt'>First paste the link of a product you desire!</div>
                        <form className='paste-link-container' onSubmit={handleSearch}>
                            <input
                                className='link'
                                placeholder='Paste link to product'
                                value={productUrl}
                                onChange={(e) => setProductUrl(e.target.value)}
                            />
                            <button className='search-button'>search</button>
                        </form>
                        {showPopup && popupProductInfo && (
                         <>
                         <div className="backdrop"></div>
                        <div class="popup">
                        <div class="popup-content">
                            <div>
                                <img src={popupProductInfo.image_url} alt="Product" />
                            </div>
                            <div class="flexer">
                                <div class='confirm-product'>Confirm:</div>
                                <div class='confirm-product'>Is this the correct product?</div>
                                <div class='product-is'>{popupProductInfo.product_name}</div>
                                <div class='product-is'>${popupProductInfo.price}</div>
                                <div class='popup-buttons'>
                                    <button className='no-button' onClick={handleClosePopup}>No</button>
                                    <button className='yes-button' onClick={handleAddToCart}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                    
                    )}
                    {showSuccessMessage && (
                    <div className="success-message">
                        Successfully added to cart.&nbsp;
                        <span 
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => navigate('/cart')}
                        >
                            View Cart
                        </span>
                    </div>
                )}
                    </div>
                    <div className='learn-box'>
                        <p className='learn-how'>Learn how to Cartpool</p>
                        <button style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={handleScrollToSlab}>
                            <img src={Downarrow} alt="Down arrow" />
                        </button>

                        
                    </div>
                    
                </div>
                
                
            </div>
            
            <div className='banner-box'>
                <div className='banner'>
                BUY NOW! LOS ANGELES IS OUR FIRST CARTPOOL LOCATION! BUY NOW! LOS ANGELES IS OUR FIRST CARTPOOL LOCATION!  BUY NOW! LOS ANGELES IS OUR FIRST CARTPOOL LOCATION!  
                </div>
            </div>

            <div className='brands-box'>
                <text className='brands-title'>BRANDS YOU LOVE ON CARTPOOL</text>
                <div className='flex'>
                    {BrandsData.slice(0, 5).map((brand, index) => (
                        <Brands key={index} imageUrl={brand.imageUrl} websiteLink={brand.websiteLink} />
                    ))}
                
                {/* <button className='rightarrow-button'>
                        <img src={smallerdownarrow} alt='right arrow button'></img>
                </button> */}
                </div>
            </div>

            <div className='trending-number1'>
                <div className={showTrending ? 'trending-inner slide-in' : 'trending-inner'}>
                <img src="https://medleyjewellery.com.au/cdn/shop/files/Artboard_9_f6b76938-ebba-401d-b49f-c7cc7ffdc997.png?v=1708486259&width=2150" alt='medley jewellery' className='trendingbrand-img'></img>
                <div className='flex' >
                <div>
                    <div style={{marginBottom:'12px'}}>
                    <text className='brands-title'>#1</text>
                    <text className='brands-title'>Trending</text>
                    <text className='brands-title'>Brand</text>
                    </div>
                    <text className='first-platform'>Medley</text>
                    
                </div>
                
                </div>
                </div>
                
            </div>

            <div className='prod-box' style={{alignItems:'center'}}>
                <text className='brands-title'>TOP 3 TRENDING PRODUCTS</text>
                <div className='flex'>
                {trendingProducts.map((product, index) => (
                    <Products 
                        key={index} 
                        productName={product.productName} 
                        price={product.price} 
                        image={product.image} 
                        productLink={product.productLink}
                    />
                ))}
                </div>
            </div>
            <div className='how-to-cartpool' id='howtocartpool'>
                <div className='gap'>
                    <p>How to Cartpool?</p>
                </div>
                <div className='icon-frame'>
                    <div>
                        <img src={Hanger} alt="shop icon"></img>
                        <p className='how-to-cart-font' >SHOP!</p>
                    </div>
                    <div>
                        <img src={Dollar} alt="pay icon"></img>
                        <p className='how-to-cart-font'>PAY!</p>
                    </div>
                    <div>
                        <img src={Ship} alt="ship icon"></img>
                        <p className='how-to-cart-font'>SHIP!</p>
                    </div>
                </div>
            </div>
            <div className='slab'>
                <div className='left-slab'>
                    <img src={Fakewebsite} alt="Website"></img>
                </div>
                <div className='right-slab'>
                    <div className='inner-right-slab'>
                        <div className='inner-right-slab-text'>
                            <div className='flex'>
                            <div className='slab-header'>1.</div>
                            <div className='shop-box'>
                                <div className='slab-header'>Shop</div>
                                <div className='slab-second-header'>Shop As Usual!</div>
                            </div>
                            <div className='shop-description'>Browse our catalogue of trending international brands, and paste a link of your favorite product from one of our offered websites.</div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className='slab'>
                <div className='right-slab'>
                        <div className='inner-right-slab'>
                            <div className='inner-right-slab-text'>
                                <div className='flex'>
                                <div className='slab-header'>2.</div>
                                <div className='shop-box'>
                                    <div className='slab-header'>Pay</div>
                                    <div className='slab-second-header'>Pay With Preferred Payment</div>
                                </div>
                                <div className='shop-description'>Pay for just your product (no shipping or duties) and we will group you with others ordering from the same place to minimize your costs.</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className='left-slab'>
                       <div className='cards'>
                        <img src={AmEx} alt='american express'></img>
                        <img src={visa} alt='visa'></img>
                        <img className='card-holder' src={group} alt='group'></img>
                        <img className='card-holder' src={Discover} alt='discover'></img>
                       </div>
                    </div>
            </div>
            <div className='slab'>
                <div className='left-slab'>
                    <div className='box-photo'>
                    <img src={confetti} className='left-slab-img' alt="confetti"></img>
                        <img src={box} className='left-slab-img' alt="box"></img>
                    </div>
                    </div>
                    <div className='right-slab'>
                        <div className='inner-right-slab'>
                            <div className='inner-right-slab-text'>
                                <div className='flex'>
                                <div className='slab-header'>3.</div>
                                <div className='shop-box'>
                                    <div className='slab-header'>Enjoy</div>
                                    <div className='slab-second-header'>Enjoy International Shopping!</div>
                                </div>
                                <div className='shop-description'>Once your group is finalized, we’ll process your share of the costs, and you can enjoy your new international goodie!"</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
            </div>
        <Footer></Footer>
        </div>
    );
};

export default LandingPage;